module.exports = __webpack_public_path__ + "static/media/Dwarf-Unselected.3bcf9e98.png";